var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button as AntdButton } from "antd";
import "./button.scss";
/**
 * Primary UI component for user interaction.
 * Supports different styles, sizes, shapes, and icons.
 * Extends Antd Button.
 *
 * @see https://ant.design/components/button/
 */
export const Button = (_a) => {
    var { shape = "default", className = "te-btn", children } = _a, rest = __rest(_a, ["shape", "className", "children"]);
    return (_jsx(AntdButton, Object.assign({ "data-testid": "btn", shape: shape, className: className }, rest, { children: children })));
};
